import style from "../../index.module.css";
import Table from "../../../../components/Table";
import more_icon from "../../../../assets/images/icons/icon-more-two.svg";
import cv_icon from "assets/images/icons/icon-note.svg";
import { ReactComponent as TrashIcon } from "assets/images/icons/icon-trash.svg";
import { ReactComponent as ChangeIcon } from "assets/images/icons/icon-edit.svg";
import { ReactComponent as MoreIcon } from "assets/images/icons/icon-more-two.svg";
import CV from "assets/cv/resume.pdf";
import MoreBtn from "components/MoreBtn";
import { Link } from "react-router-dom";
import apiRequest from "api/axios";
import { useState } from "react";
import { useEffect } from "react";
const initialValue = {
  header: [
    {
      content: "№",
    },
    {
      content: "Кандидаты",
    },
    {
      content: "Номер телефона",
    },
    {
      content: "Email",
    },
    {
      content: "Резюме",
    },
    {
      content: "Ответственный",
    },
    {
      content: (
        <div>
          <img src={more_icon} />
        </div>
      ),
      type: "html",
    },
  ],
  body: [],
};
const collums = [
    "id",
    {
      userProfile: ["first_name", "last_name"],
    },
    "phone",
    "email",
    "files",
    "added_user_id"
  ];
  
  const returnStringFromArray = (array) => {
    return array
      .map((item) => {
        if (typeof item === "object") {
          let val = Object.values(item)[0];
          if (Array.isArray(val)) {
            return val.join(",");
          }
        }
        return item;
      })
      .join(",");
  };
const SubCondidates = () => {
  const [data, setData] = useState(initialValue);
  const [pagination, setPagination] = useState({ per_page: 7, page: 1 });
  useEffect(() => {
    (async () => {
      const { data: _data, headers } = await apiRequest.get("/candidate", {
        params: {
          fields: returnStringFromArray(collums),
          "per-page": pagination.per_page,
          page: pagination.page,
        },
      });
      const total = headers.get("X-Pagination-Total-Count");
      setPagination((prev) => ({ ...prev, total: Number(total) }));
      let a = _data.data.map((item, index) => {
        const res = [];
        for (let i = 0; i < collums.length; i++) {
          const col = collums[i];

          if (col === "id") continue;

          if (typeof col === "object") { 
            Object.entries(col).forEach(([key, value]) => {
              if (key === "userProfile") {
                res.push({
                  content: (
                    <div className={style.name}>
                      <p>
                        {item[[value[1]]]} {item[[value[2]]]}
                      </p>
                    </div>
                  ),
                  type: "html",
                });
              }
            });
          }

          if (col in item) {
            res.push({ content: item[col] });
          }
        }

        res.push({
          content: (
            <MoreBtn more={more} more_icon_btn={<MoreIcon />} total={total} />
          ),
          type: "html",
        });

        return res;
      });
      setData({ header: initialValue.header, body: a });
    })();
  }, [pagination.page]);
  const more = [
    {
      text: "Изменить",
      image: <ChangeIcon />,
      id: 1,
    },
    {
      text: "Удалить",
      image: <TrashIcon />,
      id: 2,
    },
  ];

  return (
    <div className={`${style.tabel_wrapper} p_0 mt_24`}>
      <Table
        currentPage={pagination.page}
        data={data}
        page={pagination.per_page}
        total={pagination.total}
        changeCurrentPage={(page) =>
          setPagination((prev) => ({ ...prev, page }))
        }
      />
    </div>
  );
};
export default SubCondidates;